export const eccehomo = {
	nombre: "Ecce Homo",
	dia: "Martes Santo",
	nombrecompleto:
		"Real y Venerable Archicofradía de Nuestro Padre Jesús del Ecce-Homo, María Santísima de las Angustias y San Juan Evangelista",
	sede: "Iglesia de la Conversión de San Pablo",
	pasos: 2,
	distancia: [1320, 634],
	penitentes: 150,
	cargadores: 92,
	web: "http://www.diariodecadiz.es/semana_santa/Ecce-Homo_0_1229277816.html",

	ida: [
		// CATEDRAL
		{ lng: -6.2965205, lat: 36.5330408 },
		{ lng: -6.2964159, lat: 36.532974 },
		{ lng: -6.2967914, lat: 36.5325397 },
		{ lng: -6.2971535, lat: 36.5330785 },
		{ lng: -6.2976846, lat: 36.5335796 },
		{ lng: -6.2967606, lat: 36.5341916 },
		{ lng: -6.296251, lat: 36.5339336 },
		{ lng: -6.2960109, lat: 36.5339643 },
		{ lng: -6.2947322, lat: 36.5325397 },
		{ lng: -6.294364, lat: 36.5327261 },
		{ lng: -6.2922133, lat: 36.5302949 },
		{ lng: -6.2928379, lat: 36.5297864 },
		{ lng: -6.2933367, lat: 36.5297303 },
		{ lng: -6.2945294, lat: 36.5296271 },
		{ lng: -6.2946296, lat: 36.5293424 },
		{ lng: -6.295107, lat: 36.5294458 },
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2956971, lat: 36.5291398 },
		{ lng: -6.295445, lat: 36.5297605 },
		{ lng: -6.2956676, lat: 36.5299588 },
		{ lng: -6.2952921, lat: 36.5303424 },
		{ lng: -6.2950225, lat: 36.5308338 },
		{ lng: -6.2949219, lat: 36.5308392 },
		{ lng: -6.2949246, lat: 36.5314524 },
		{ lng: -6.2964575, lat: 36.5317735 },
		{ lng: -6.2967539, lat: 36.5325149 },
		{ lng: -6.2963623, lat: 36.5329826 },
		{ lng: -6.2965058, lat: 36.5330614 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-27T18:30",
			latlng: [36.53306, -6.2965]
		},
		{
			name: "Nueva",
			hora: "2018-03-27T21:15",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-27T22:15",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-27T23:20",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-27T23:45",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-27T23:55",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Ancha",
			"Sagasta (Dcha.)",
			"San Pedro (Dcha.)",
			"Beato Diego de Cadiz",
			"Rosario",
			"Marqués de Valdeiñigo",
			"San Francisco (Dcha.)",
			"Plaza San Agustín",
			"San Francisco",
			"Plaza de San Agustín",
			"San Francisco",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena"],
		["Ancha"]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/eccehomo.js